// Impatiently waiting for something like https://github.com/WICG/color-api to exist
//   export function lightness(color) { return new Color(color).get('lch', 'l') / 100; }


// let getColorUsingCSS = (() => {
// 	if (typeof document === 'undefined') {
// 		return () => null;
// 	}
// 	let cache = {};
// 	return value => {
// 		if (cache[value]) {
// 			return cache[value];
// 		}
// 		document.head.style.color = '';
// 		covument.head.style.color = value;
// 		let result = document.head.style.color && getComputedStyle(document.head).color;
// 		return cache[value] = (result || null);
// 	};
// })();

export function parseColorString(str) {
	if (!str || typeof str !== 'string') {
		return { r: 0, g: 0, b: 0 };
	}
	// Makes some assumptions for simplicity
	let components;
	if (str.startsWith('#')) {
		components = str.match(/([\da-f]{1,2})([\da-f]{1,2})([\da-f]{1,2})/i)?.slice(1)?.map(v => parseInt(v.length === 1 ? v + v : v, 16));
	} else {
		components = str.match(/-?[\d.]+/g)?.map(Number);
	}
	// if (!components || components.length < 3) {
	// 	let parsedString = getColorUsingCSS(str);
	// 	if (parsedString && parsedString !== str) {
	// 		return parseColorString(parsedString);
	// 	}
	// }
	const [r = 0, g = 0, b = 0] = components?.map(n => n / 255) || [];
	return { r, g, b };
}

export function lightness(color) {
	if (typeof color === 'string') {
		color = parseColorString(color);
	}
	if (!color) {
		return 0;
	}
	const { r = 0, g = 0, b = 0 } = color;
	// Using coefficients from https://stackoverflow.com/a/596243/1336843
	return r * .2126 + g * .7152 + b * .0722;
}